<template>
    <div>
        <div v-if="error" id="flex-container">
            <div class="container" style="height: 500px"></div>
        </div>
        <div v-else id="flex-container">
            <!-- 사용자 정보 -->
            <section id="promo-top" v-bind:class="{ blackfriday: isBlackFriday }">
                <div class="top-header">
                    <div class="todologo">
                        <img
                            v-if="$store.state.lang === 'ko'"
                            class="todomath-logo"
                            src="@/assets/promotion/img-todomath-logo-ko@3x.png"
                            alt="todomath Logo"
                        />
                        <img
                            v-else
                            class="todomath-logo"
                            src="@/assets/promotion/img-todomath-logo-en@3x.png"
                            alt="todomath Logo"
                        />
                    </div>
                    <div class="email-address">
                        <p class="main-text">
                            <span class="user-email">{{ stripeInfo.email }}</span>
                            <br />
                            {{ l10nPromotion.All_Promotion_Landing_body1_message1 }}
                        </p>
                    </div>
                </div>
            </section>

            <!-- 기간 한정 세일 -->
            <section id="promo-middle" v-bind:class="{ blackfriday: isBlackFriday }">
                <div class="limit-sale">
                    <p class="sale-text">{{ l10nPromotion.All_Promotion_Landing_body1_message2 }}</p>
                </div>
                <div class="closing-time">
                    <div class="deco-clock">
                        <div class="deco-clock-unit day">{{ duration.day10 }}</div>
                        <div class="deco-clock-unit day">{{ duration.day1 }}</div>
                        <div
                            class="time-unit"
                        >{{ l10nPromotion.All_Promotion_Landing_body1_message3 }}</div>
                    </div>
                    <div class="timer-separator">:</div>
                    <div class="deco-clock">
                        <div class="deco-clock-unit hour">{{ duration.hour10 }}</div>
                        <div class="deco-clock-unit hour">{{ duration.hour1 }}</div>
                        <div
                            class="time-unit"
                        >{{ l10nPromotion.All_Promotion_Landing_body1_message4 }}</div>
                    </div>
                    <div class="timer-separator">:</div>
                    <div class="deco-clock">
                        <div class="deco-clock-unit minute">{{ duration.min10 }}</div>
                        <div class="deco-clock-unit minute">{{ duration.min1 }}</div>
                        <div
                            class="time-unit"
                        >{{ l10nPromotion.All_Promotion_Landing_body1_message5 }}</div>
                    </div>
                    <div class="timer-separator">:</div>
                    <div class="deco-clock">
                        <div class="deco-clock-unit second">{{ duration.sec10 }}</div>
                        <div class="deco-clock-unit second">{{ duration.sec1 }}</div>
                        <div
                            class="time-unit"
                        >{{ l10nPromotion.All_Promotion_Landing_body1_message6 }}</div>
                    </div>
                </div>
            </section>

            <!-- 할인율 / 할인가격 -->
            <section v-if="this.$route.query.type==='A'" id="coupon-box" v-bind:class="{ blackfriday: isBlackFriday }">
                <div class="top-coupon">
                    <div class="coupon-text">
                        <p
                            class="discount-text"
                        >{{ l10nPromotion.All_Promotion_Landing_body1_message7 }}</p>
                        <p class="original-price">
                            {{ l10nPromotion.All_Promotion_Landing_body1_message8 }}
                            <span
                                class="del-price"
                            >$ {{ product.originalPrice }}</span>
                        </p>
                        <h1 class="discount-price">$ {{ product.price }}</h1>
                        <p class="percent-off">
                            <img class="down-arrow" src="@/assets/promotion/img-down-arrow@3x.png" />
                            {{ product.discountRate }}% OFF
                        </p>
                    </div>
                </div>
            </section>

            <section v-else id="coupon-box-b" v-bind:class="{ blackfriday: isBlackFriday }">
                <div class="top-coupon-b">
                    <div class="coupon-text-b">
                        <p
                            class="discount-text-b"
                        >{{ l10nPromotion.All_Promotion_Landing_body1_message7 }}</p>
                        <p class="percent-off-b">
                            <img
                                class="down-arrow-b"
                                src="@/assets/promotion/img-down-arrow@3x.png"
                            />
                            <img
                                v-if="product.discountRate == 30"
                                class="down-rate"
                                src="@/assets/promotion/img-rate-30@3x.png"
                            />
                            <img
                                v-else-if="product.discountRate == 35"
                                class="down-rate"
                                src="@/assets/promotion/img-rate-35@3x.png"
                            />
                            <img
                                v-else-if="product.discountRate == 40"
                                class="down-rate"
                                src="@/assets/promotion/img-rate-40@3x.png"
                            />
                            <img
                                v-else-if="product.discountRate == 50"
                                class="down-rate"
                                src="@/assets/promotion/img-rate-50@3x.png"
                            />
                            <span v-else class="down-figure-b">
                                {{ product.discountRate }}
                                <sub class="down-percent-b">%</sub>
                            </span>
                        </p>
                        <p class="price-text-b">
                            <span
                                class="ori-price-b"
                            >{{ l10nPromotion.All_Promotion_Landing_body1_message8 }}&nbsp;</span>
                            <span class="del-price-b">$ {{ product.originalPrice }} &nbsp; &nbsp;</span>
                            <span class="discount-price-b">&nbsp;$ {{ product.price }}</span>
                        </p>
                    </div>
                </div>
            </section>


            <!-- 고객 주의사항 -->
            <section id="notice">
                <div class="notice-box">
                    <p
                        class="notice-text"
                    >• {{ l10nPromotion.All_Promotion_Landing_body1_message9 }}</p>
                    <p
                        class="notice-text"
                    >• {{ l10nPromotion.All_Promotion_Landing_body1_message10 }}</p>
                </div>
            </section>

            <!-- 결제 버튼 -->
            <div class="next">
                <button
                    class="subm"
                    @click="checkout"
                >{{ l10nPromotion.All_Promotion_Landing_body1_message11 }}</button>
            </div>

            <!-- 모바일용 이미지 -->
            <section id="img-bottom"  v-bind:class="{ blackfriday: isBlackFriday }">
                <div class="friends"></div>
            </section>
        </div>

        <div v-if="!error">
            <div class="spline"></div>

            <div class="container">
                <mq-layout mq="mobile">
                    <MobileFooter></MobileFooter>
                </mq-layout>
                <mq-layout mq="laptop+">
                    <LaptopFooter></LaptopFooter>
                </mq-layout>
            </div>
        </div>

        <modal
            name="msgPopup"
            :classes="'msgPopup'"
            :clickToClose="false"
            :width="500"
            :height="'auto'"
        >
            <div class="popup" align="center">
                <div class="content">
                    <pre v-if="error">{{ error }}</pre>
                    <pre v-else>{{ l10nPromotion.All_Promotion_Landing_body1_message12 }}</pre>
                </div>
                <button
                    @click="ok"
                    class="okbutton"
                    align="center"
                >{{ l10nParent.All_Parents_FindPassword_Title1_Button1 }}</button>
            </div>
        </modal>

        <vue-stripe-checkout
            ref="checkoutRef"
            :image="stripeInfo.image"
            :name="stripeInfo.name"
            :description="stripeInfo.description"
            :currency="stripeInfo.currency"
            :amount="stripeInfo.amount"
            :email="stripeInfo.email"
            :panel-label="stripeInfo.label"
            :allow-remember-me="false"
            @done="done"
        ></vue-stripe-checkout>
    </div>
</template>
<script>
import LaptopFooter from "@/components/footer/FooterLaptop.vue";
import MobileFooter from "@/components/footer/FooterMobile.vue";
import Vue from "vue";
import VueStripeCheckout from "vue-stripe-checkout";
import axios from "axios";
import moment from "moment";


export default {
    name: "Wageni",
    components: { LaptopFooter, MobileFooter },
    async created() {
        Vue.use(VueStripeCheckout, this.stripeKey);

        const id = this.$route.params.id;
        if (isNaN(id)) {
            this.$router.push("/notFound");
            return;
        }

        const verify = await axios.post(
            this.env.protocol + this.env.urlAPI + "/session/verify", {
                sessionId: this.$store.getters.sessionId
            },
            {
                headers: {
                    "content-type": "application/json; charset=UTF-8"
                }
            }
        );

        if (
            !verify.data ||
            !verify.data.result ||
            !verify.data.data.accountId
        ) {
            const encodedPath = encodeURIComponent(this.$route.fullPath);
            this.$store
                .dispatch("signout", {})
                .then(() =>
                    this.$router.push("/signin?redirect=" + encodedPath)
                );
            return;
        }

        const accountId = verify.data.data.accountId;
        const trigger = await this.axios.post(
            this.env.protocol + this.env.urlAPI + "/wageni/trigger", {
                accountId: accountId,
                id: id
            },
            {
                headers: {
                    "content-type": "application/json; charset=UTF-8"
                }
            }
        );
        if (!trigger || !trigger.data || !trigger.data.result) {
            switch (trigger.data.errorCode) {
                case "CAD14":
                    this.error = this.l10nParent.All_Parents_Signin_Title1_ErrorMessage4;
                    break;
                default:
                    this.error = this.l10nParent.All_Parents_Signin_Title1_ErrorMessage3;
                    break;
            }
            return;
        }

        this.expdate = moment(trigger.data.data.expdate.substring(0, 10));
        this.stripeInfo.email = trigger.data.data.email;
        this.stripeInfo.amount = trigger.data.data.product.price * 100;
        this.stripeInfo.code = trigger.data.data.product.code;
        this.product = trigger.data.data.product;
        this.sendLogId = trigger.data.data.id;
        this.triggerId = trigger.data.data.triggerId;
        this.showClosingTime();
    },
    updated() {
        if (this.error) this.$modal.show("msgPopup");
        this.interval = setInterval(() => {
            this.showClosingTime();
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    data() {
        const textParent = require("@/text/parent/laptop.js").default;
        const l10nParent = textParent[this.$store.state.lang]
            ? textParent[this.$store.state.lang]
            : textParent["en"];
        const textPromotion = require("@/text/promotion/laptop.js").default;
        const l10nPromotion = textPromotion[this.$store.state.lang]
            ? textPromotion[this.$store.state.lang]
            : textPromotion["en"];
        return {
            l10nParent: l10nParent,
            l10nPromotion: l10nPromotion,
            sessionId: this.$store.state.sessionId,
            stripeInfo: {
                image:
                    (this.$store.state.lang === "ko")
                        ? require("@/assets/promotion/img-todomath-logo-ko@3x.png")
                        : require("@/assets/promotion/img-todomath-logo-en@3x.png"),
                email: "",
                name: "Enuma",
                code: "",
                description: "Purchase",
                currency: "usd",
                amount: 0,
                label: "Pay US {{amount}}"
            },
            product: {
                code: "",
                price: 0,
                originalPrice: 0,
                discountRate: 0
            },
            duration: {
                day10: 0,
                day1: 0,
                hour10: 0,
                hour1: 0,
                min10: 0,
                min1: 0,
                sec10: 0,
                sec1: 0
            },
            stripeKey: this.$store.state.env.env === 'live' ? 'pk_live_qZDVrvIFBBhKYVSPTY5i4eSB' : 'pk_test_Rq5gZjuOlEB6D8vXwzuTislX',
            env: this.$store.state.env,
            rawHtml: "",
            sendLogId: null,
            triggerId: null,
            expdate: null,
            interval: null,
            error: "",
            isBlackFriday: (this.$route.query.type==='C')
        };
    },
    methods: {
        ok() {
            this.$router.push("/");
        },
        async checkout() {
            const { token, args } = await this.$refs.checkoutRef.open();
        },
        done({ token, args }) {
            const data = {
                sessionId: this.sessionId,
                tokenId: token.id,
                email: this.stripeInfo.email,
                productId: this.stripeInfo.code,
                sendLogId: this.sendLogId, 
                triggerId: this.triggerId 
            };
            const self = this;
            this.axios
                .post(
                    this.env.protocol + this.env.urlAPI + "/stripe/order",
                    null,
                    {
                        params: {
                            text: JSON.stringify(data)
                        }
                    },
                    {
                        headers: {
                            "content-type":
                                "application/x-www-form-urlencoded; charset=UTF-8"
                        }
                    }
                )
                .then(function(rs) {
                    if (!rs.data.result) {
                        self.error = "Unknown error occured";
                    }
                    self.$modal.show("msgPopup");

                    // window.location.reload();
                });
        },
        showClosingTime() {
            if (this.expdate) {
                const diff = this.expdate.diff(moment());
                const duration = moment.duration(diff < 0 ? 0 : diff);
                const d = (
                    "00" +
                    (duration.get("days") > 99
                        ? 99
                        : duration.get("days")
                    ).toString()
                ).split("");
                const h = ("00" + duration.get("hours").toString()).split("");
                const m = ("00" + duration.get("minutes").toString()).split("");
                const s = ("00" + duration.get("seconds").toString()).split("");
                this.duration.day10 = d[d.length - 2];
                this.duration.day1 = d[d.length - 1];
                this.duration.hour10 = h[h.length - 2];
                this.duration.hour1 = h[h.length - 1];
                this.duration.min10 = m[m.length - 2];
                this.duration.min1 = m[m.length - 1];
                this.duration.sec10 = s[s.length - 2];
                this.duration.sec1 = s[s.length - 1];
            }
        }
    }
};
</script>
<style  scoped>
* {
    margin: 0;
    padding: 0;
}

body {
    background-color: #f6f6f6;
    text-rendering: optimizeLegibility;
}

#flex-container {
    width: 100%;
    margin: 0 auto;
    flex-wrap: nowrap;

    flex-direction: column;
    justify-content: center;
    align-self: flex-start;
    background-color: #ffffff;

    -ms-box-orient: horizontal;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
}

.container {
    max-width: 1024px;
    margin: 0 auto;
}

/********* Header image ***********/

#promo-top {
    background: url("~@/assets/promotion/img-promotion-top-bg.png");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: auto;
}

#promo-top.blackfriday {
    background: url("~@/assets/promotion/img-promotion-bf-top-bg.png");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: auto;
    color: #fffcf7;
}

.top-header {
    width: 1024px;
    margin: 0 auto;
}

.todologo {
    padding-top: 21px;
    padding-left: 10px;
}

.todomath-logo {
    width: 79px;
    height: 60px;
    display: inline-block;
}

.email-address {
    margin-top: 121px;
    margin-bottom: 325px;
}

.main-text {
    font-size: 56px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.39;
    letter-spacing: -2px;
    text-align: center;
}

.user-email {
    color: #15a3e8;
}

#promo-top.blackfriday .user-email {
    color: #6eeed7;
}

/********* 기간 한정 세일 ***********/

#promo-middle {
    width: 1024px;
    margin: 0 auto;
    background: url("~@/assets/promotion/img-deco@3x.png");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: contain;
}

#promo-middle.blackfriday {
    background: url("~@/assets/promotion/img-deco-bf@3x.png");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: contain;
}

.limit-sale {
    margin-top: 40px;
    margin-bottom: 43px;
}

.sale-text {
    text-align: center;
    font-size: 76px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.37;
    letter-spacing: -3px;
    text-align: center;
    color: #41403e;
}

.closing-time {
    text-align: center;
    margin: 0 auto;
    font-size: 0px;
}

.deco-clock {
    display: inline-block;
}

.deco-clock-unit {
    display: inline-block;
    font-size: 76px;
    color: #ffffff;
    font-weight: 600;
    padding: 1px 20px;
    border-radius: 20px;
    margin-right: 8px;
}

.deco-clock-unit.day {
    background-color: #af23d8;
}

.deco-clock-unit.hour {
    background-color: #17a3e8;
}

.deco-clock-unit.minute {
    background-color: #f55831;
}

.deco-clock-unit.second {
    background-color: #ffcc23;
}

.timer-separator {
    display: inline-block;
    margin-left: 3px;
    margin-right: 11px;
    font-size: 76px;
    color: #999;
    font-weight: 500;
    vertical-align: top;
}

.time-unit {
    display: block;
    padding-top: 8px;
    padding-bottom: 25px;
    text-align: center;
    font-size: 22px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    color: #999999;
}

/********* 고객 주의사항 *********/

#notice {
    width: 1024px;
    margin: 0 auto;
}

.notice-box {
    padding-top: 10px;
    padding-left: 78px;
}

.notice-text {
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.57;
    letter-spacing: normal;
    color: #999999;
    padding-bottom: 9px;
}

.help {
    font-weight: 600;
    color: #42c0ff;
}

.spline {
    width: 100%;
    padding-top: 1px;
    background-color: #e6e6e6;
}

/********* 결제 버튼 ***********/

.subm {
    width: 380px;
    height: 100px;
    border-radius: 50px;
    border: solid 3px #41403e;
    color: #41403e;
    background: #6eeed7;
    font-size: 32px;
    font-weight: 600;
    letter-spacing: -1px;
    cursor: pointer;
}

.next {
    margin-top: 50px;
    margin-bottom: 120px;
    text-align: center;
}

a {
    color: #42c0ff;
}

pre {
    white-space: pre-wrap;
    word-wrap: break-word;
}

/* Popup */

.v--modal-overlay {
    background: rgba(0, 0, 0, 0.05);
}

.msgPopup {
    border-radius: 12px;
}

.popup {
    margin-left: 12px;
    padding: 30px;
    background: #fff;
    border-radius: 12px;
    box-sizing: border-box;
    width: 460px;
    position: relative;
}

.popup .content {
    width: 400px;
    font-size: 22px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.45;
    letter-spacing: -0.8px;
    text-align: center;
    color: #41403e;
    overflow: auto;
    padding-bottom: 40px;
}

.okbutton {
    width: 317px;
    height: 64px;
    border-radius: 32px;
    border: solid 3px #41403e;
    color: #41403e;
    background: #6eeed7;
    font-size: 22px;
    font-weight: 600;
    cursor: pointer;
}

/********* 쿠폰 상자 ***********/
#coupon-box {
    background: url("~@/assets/promotion/img-coupon.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
}
#coupon-box.blackfriday {
    background: url("~@/assets/promotion/img-coupon-bf.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
}

.top-coupon {
    width: 1024px;
    margin: 0 auto;
}
.coupon-text {
    padding-top: 110px;
    color: #fffcf7;
    width: 100%;
    margin: 0 auto;
}

.discount-text {
    font-size: 32px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: -1px;
    text-align: center;
    padding-bottom: 20px;
}

.original-price {
    opacity: 0.6;
    font-size: 32px;
    font-weight: 400;
    line-height: 1;
    letter-spacing: -0.73px;
    color: #fffcf7;
    text-align: center;
    padding-bottom: 11px;
}

.del-price {
    text-decoration: line-through;
    padding-left: 16px;
}

.discount-price {
    font-size: 100px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -2.5px;
    text-align: center;
    color: #fffcf7;
    padding-bottom: 27px;
}

.percent-off {
    font-size: 42px;
    font-weight: 600;
    line-height: 1;
    align-self: center;
    letter-spacing: -1px;
    color: #fffcf7;
    text-align: center;
    padding-top: 49px;
    padding-bottom: 51px;
}

.down-arrow {
    width: 54px;
    height: 50px;
    align-self: center;
    vertical-align: middle;
    margin-right: 16px;
    display: inline-flex;
}

/********* 프로모션 B ***********/
#coupon-box-b {
    background: url("~@/assets/promotion/img-coupon.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
}
#coupon-box-b.blackfriday {
    background: url("~@/assets/promotion/img-coupon-bf.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
}

.top-coupon-b {
    width: 1024px;
    margin: 0 auto;
}
.coupon-text-b {
    padding-top: 110px;
    color: #fffcf7;
    width: 100%;
    margin: 0 auto;
}

.discount-text-b {
    font-size: 32px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: -1px;
    text-align: center;
    padding-bottom: 20px;
}

.percent-off-b {
    text-align: center;
    padding-bottom: 78px;
}

.down-arrow-b {
    width: 115px;
    height: 105px;
    align-self: center;
    vertical-align: middle;
    padding-right: 12px;
    padding-top: 10px;
    display: inline-flex;
}

.down-figure-b {
    font-size: 80px;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    vertical-align: bottom;
    line-height: 1;
}

.down-percent-b {
    font-size: 20px;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    vertical-align: bottom;
    line-height: 3;
}

.down-rate {
    width: 259px;
    height: 130px;
    padding-top: 10px;
    align-self: center;
    vertical-align: middle;
}

.price-text-b {
    font-size: 32px;
    font-weight: 400;
    line-height: 1;
    letter-spacing: -0.73px;
    color: #fffcf7;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 55px;
}

.ori-price-b {
    opacity: 0.6;
}

.del-price-b {
    opacity: 0.6;
    background: url("~@/assets/promotion/img-cancel-line@3x.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    padding-left: 5px;
    padding-right: 5px;
}

.discount-price-b {
    font-weight: 600;
    opacity: inherit;
}

@media (max-width: 1024px) {
    /********* Header Tablet ***********/

    #promo-top {
        background: url("~@/assets/promotion/img-promotion-top-bg-m.png");
        background-position: top center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    #promo-top.blackfriday {
        background: url("~@/assets/promotion/img-promotion-bf-top-bg-m.png");
        background-position: top center;
        background-repeat: no-repeat;
        background-size: cover;
        color: #fffcf7;
    }

    .todologo {
        padding-top: 19px;
        padding-left: 35px;
    }

    .todomath-logo {
        width: 79px;
        height: 62px;
        display: inline-block;
    }

    .top-header {
        width: auto;
        margin: 0 auto;
    }

    .main-text {
        font-size: 48px;
        letter-spacing: -1.5px;
    }

    .email-address {
        margin-top: 178px;
        margin-bottom: 374px;
    }

    /********* 기간한정세일 Tablet ***********/

    #promo-middle {
        width: auto;
        margin: 0 auto;
        background: url("~@/assets/promotion/img-deco-m@3x.png");
        background-position: top center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    #promo-middle.blackfriday {
        background: url("~@/assets/promotion/img-deco-bf-m@3x.png");
        background-position: top center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .limit-sale {
        margin-top: 106px;
        margin-bottom: 45px;
    }

    .sale-text {
        text-align: center;
        font-size: 64px;
        line-height: 1.25;
        letter-spacing: -2.5px;
    }

    .deco-clock-unit {
        font-size: 56px;
        padding: 4px 17px;
        border-radius: 15.7px;
        margin-right: 5px;
    }

    .timer-separator {
        font-size: 56px;
        margin-left: 5px;
        margin-right: 7px;
    }

    .time-unit {
        padding-top: 12px;
        padding-bottom: 11px;
    }

    /********* 고객 주의사항 Tablet *********/

    #notice {
        width: auto;
        margin: 0 auto;
    }

    .notice-box {
        padding-top: 28px;
        padding-left: 35px;
        padding-right: 35px;
    }

    .notice-text {
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        padding-bottom: 16px;
    }

    /********* 결제버튼 Tablet ***********/

    .subm {
        width: 100%;
        max-width: 680px;
    }

    .next {
        margin-top: 71px;
        margin-bottom: 80px;
        margin-left: 32px;
        margin-right: 32px;
        text-align: center;
    }

    #img-bottom {
        background: url("~@/assets/promotion/img-bottom-m.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: auto;
    }
    #img-bottom.blackfriday {
        background: url("~@/assets/promotion/img-bottom-bf-m.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: auto;
    }

    .friends {
        width: auto;
        height: 227px;
        margin: 0 auto;
    }

    .spline {
        height: 2px;
    }

    /********* 쿠폰상자 Tablet ***********/
    #coupon-box {
        background: url("~@/assets/promotion/img-coupon-m.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    #coupon-box.blackfriday {
        background: url("~@/assets/promotion/img-coupon-bf-m.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .top-coupon {
        width: auto;
        margin: 0 auto;
    }
    .coupon-text {
        padding-top: 119px;
        color: #fffcf7;
    }

    .discount-text {
        font-size: 34px;
        font-weight: 600;
        padding-bottom: 20px;
    }

    .discount-price {
        font-size: 100px;
        font-weight: 700;
        letter-spacing: -2.5px;
        text-align: center;
        color: #fffcf7;
    }

    .percent-off {
        padding-top: 49px;
        padding-bottom: 28px;
    }

    /********* 쿠폰상자 Tablet ***********/
    #coupon-box-b {
        background: url("~@/assets/promotion/img-coupon-m.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    #coupon-box-b.blackfriday {
        background: url("~@/assets/promotion/img-coupon-bf-m.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .top-coupon-b {
        width: auto;
        margin: 0 auto;
    }
    .coupon-text-b {
        padding-top: 119px;
        color: #fffcf7;
    }

    .discount-text-b {
        font-size: 34px;
        font-weight: 600;
        padding-top: 10px;
    }

    .percent-off-b {
        padding-top: 20px;
        padding-bottom: 100px;
    }
}


@media (max-width: 711px) {
    /********* Header Mobile ***********/
    #flex-container {
        width: auto;
    }

    .todologo {
        padding-top: 19px;
        padding-left: 35px;
    }

    .todomath-logo {
        width: 50px;
        height: 37px;
        display: inline-block;
    }

    .top-header {
        width: auto;
        margin: 0 auto;
    }

    .main-text {
        font-size: 26px;
        letter-spacing: -1.5px;
    }

    .email-address {
        margin-top: 100px;
        margin-bottom: 200px;
    }

    /********* 기간한정세일 모바일 ***********/

    #promo-middle {
        width: 100%;
        margin: 0 auto;
        background: url("~@/assets/promotion/img-deco-m@3x.png");
        background-position: top center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .limit-sale {
        margin-top: 70px;
        margin-bottom: 45px;
    }

    .sale-text {
        text-align: center;
        font-size: 40px;
        line-height: 1.25;
        letter-spacing: -2.5px;
    }

    .deco-clock-unit {
        font-size: 30px;
        padding: 3px 10px;
        border-radius: 10px;
        margin-right: 4px;
    }

    .timer-separator {
        font-size: 30px;
        margin-left: 0px;
        margin-right: 3px;
    }

    .time-unit {
        font-size: 16px;
        padding-top: 12px;
        padding-bottom: 11px;
    }

    /********* 고객 주의사항 *********/

    #notice {
        width: auto;
        margin: 0 auto;
    }

    .notice-box {
        padding-top: 20px;
        padding-left: 5%;
        padding-right: 5%;
    }

    .notice-text {
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        padding-bottom: 8px;
    }

    /********* 결제버튼 모바일 ***********/

    .subm {
        width: 100%;
        max-width: 420px;
        min-width: 360px;
        height: 80px;
        border-radius: 40px;
        padding: 20px 125px 20px 125px;
        font-size: 24px;
        letter-spacing: -1.21px;
        cursor: pointer;
    }

    .next {
        margin-top: 40px;
        margin-bottom: 40px;
        margin-left: 32px;
        margin-right: 32px;
        text-align: center;
    }

    #img-bottom {
        background: url("~@/assets/promotion/img-bottom-m.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    #img-bottom.blackfriday {
        background: url("~@/assets/promotion/img-bottom-bf-m.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .friends {
        width: auto;
        height: 160px;
        margin: 0 auto;
    }

    .spline {
        height: 2px;
    }

    /********* 쿠폰상자 모바일***********/
    .top-coupon {
        width: auto;
        margin: 0 auto;
    }

    .coupon-text {
        padding-top: 100px;
        color: #fffcf7;
    }

    .discount-text {
        font-size: 20px;
        font-weight: 600;
        padding-bottom: 15px;
    }

    .discount-price {
        font-size: 60px;
        font-weight: 700;
        letter-spacing: -2.5px;
        text-align: center;
        color: #fffcf7;
    }

    .original-price {
        font-size: 20px;
    }

    .percent-off {
        font-size: 24px;
        padding-top: 20px;
        padding-bottom: 10px;
    }

    .down-arrow {
        width: 33px;
        height: 30px;
        padding-right: 10px;
        padding-bottom: 15px;
    }

    /********* 프로모션 B 모바일***********/

    .top-coupon-b {
        width: auto;
        margin: 0 auto;
    }

    .coupon-text-b {
        padding-top: 80px;
        color: #fffcf7;
    }

    .discount-text-b {
        font-size: 23px;
        font-weight: 600;
    }

    .percent-off-b {
        padding-top: 0px;
        padding-bottom: 42px;
    }

    .down-arrow-b {
        width: 69px;
        height: 63px;
        vertical-align: middle;
        padding-right: 10px;
        display: inline-flex;
    }

    .down-rate {
        width: 160px;
        height: 78px;
        vertical-align: middle;
    }

    .down-figure-b {
        font-size: 44px;
        font-weight: 700;
        font-style: normal;
        font-stretch: normal;
        vertical-align: bottom;
        line-height: 1;
    }

    .down-percent-b {
        font-size: 16px;
        font-weight: 700;
        font-style: normal;
        font-stretch: normal;
        vertical-align: bottom;
        line-height: 3;
    }

    .price-text-b {
        font-size: 23px;
        font-weight: 400;
        line-height: 1;
        letter-spacing: -0.73px;
        color: #fffcf7;
        text-align: center;
        padding-top: 20px;
        padding-bottom: 40px;
    }

    .discount-price-b {
        font-weight: 600;
        opacity: inherit;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/promotion/Wageni.vue